import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ContentAnalysis } from "./analysisHelpers.js/contentAnalysis";
import { LinkingAnalysis } from "./analysisHelpers.js/linkingAnalysis";
import { MetaAnalysis } from "./analysisHelpers.js/metaDataAnalysis";
import { PlanAnlysis } from "./analysisHelpers.js/planAnalysis";
import { SemanticsAnalysis } from "./analysisHelpers.js/semanticsAnalysis";
import { TitleAnalysis } from "./analysisHelpers.js/titleAnalysis";
import { UrlAnalysis } from "./analysisHelpers.js/urlAnalysis";
import { ContentCompetitorAnalysis } from "./competitorAnalysis/contentCompetitorAnalysis";
import { LinkingCompetitorAnalysis } from "./competitorAnalysis/linkingCompetitorAnalysis";
import { MetadataCompetitorAnalysis } from "./competitorAnalysis/metaDataCompetitorAnalysis";
import { PlanCompetitorAnalysis } from "./competitorAnalysis/planCompetitorAnalysis";
import { SemanticsCompetitorAnalysis } from "./competitorAnalysis/semanticsCompetitorAnalysis";
import { TitleCompetitorAnalysis } from "./competitorAnalysis/titleCompetitorAnalysis";
import { UrlCompetitorAnalysis } from "./competitorAnalysis/urlCompetitorAnalysis";
import { dispatch } from "../../../../../redux/store";
import { setActivePanel } from "../../../../../redux/slices/panelSlice";

const LaunchAnalysisBtn = ({
  userInfo,
  disabled,
  formikProps,
  analysis,
  type,
  showModalHandle,
  showModal,
}) => {
  const { t } = useTranslation();
  const competitorResults = useSelector(
    (state) => state.competitorAnalysis.data?.data
  );

  return (
    <Box sx={{ px: 2, mb: 2 }}>
      {/* Plan  */}
      {analysis && type === "plan" && (
        <>
          <PlanAnlysis analysis={analysis}></PlanAnlysis>

          {/* Competitor Analysis */}
          <PlanCompetitorAnalysis
            competitorResults={competitorResults}
          ></PlanCompetitorAnalysis>
        </>
      )}

      {/* Url Slug */}
      {analysis && type === "slug" && (
        <>
          <UrlAnalysis analysis={analysis}></UrlAnalysis>

          {/* Competitor Analysis */}
          <UrlCompetitorAnalysis
            competitorResults={competitorResults}
          ></UrlCompetitorAnalysis>
        </>
      )}

      {/* Title */}
      {analysis && type === "h1" && (
        <>
          <TitleAnalysis analysis={analysis}></TitleAnalysis>
          {/* Competitor Analysis */}
          <TitleCompetitorAnalysis
            competitorResults={competitorResults}
            analysis={analysis}
          ></TitleCompetitorAnalysis>
        </>
      )}

      {/* Content */}
      {analysis && type === "content" && (
        <>
          <ContentAnalysis analysis={analysis}></ContentAnalysis>

          {/* Competitor Analysis */}

          <ContentCompetitorAnalysis
            competitorResults={competitorResults}
          ></ContentCompetitorAnalysis>
        </>
      )}

      {/* MetaData */}
      {analysis && type === "metadata" && (
        <>
          <MetaAnalysis analysis={analysis}></MetaAnalysis>

          {/* Competitor Analysis */}
          <MetadataCompetitorAnalysis
            competitorResults={competitorResults}
          ></MetadataCompetitorAnalysis>
        </>
      )}

      {/* Semantics */}
      {analysis && type === "semantics" && (
        <>
          <SemanticsAnalysis analysis={analysis}></SemanticsAnalysis>
          <SemanticsCompetitorAnalysis
            competitorResults={competitorResults}
            showModal={showModal}
            formikProps={formikProps}
            showModalHandle={showModalHandle}
          ></SemanticsCompetitorAnalysis>
        </>
      )}

      {/* Linking */}
      {analysis && type === "linking" && (
        <>
          <LinkingAnalysis analysis={analysis}></LinkingAnalysis>
          <LinkingCompetitorAnalysis
            competitorResults={competitorResults}
            showModal={showModal}
            showModalHandle={showModalHandle}
            analysis={analysis}
            formikProps={formikProps}
          ></LinkingCompetitorAnalysis>
        </>
      )}

      {(!competitorResults ||
        (competitorResults && Object.keys(competitorResults).length < 2)) && (
        <div>
          <button
            onClick={() => dispatch(setActivePanel("outline"))}
            className="text-sm font-semibold mt-8 bg-pink-400 rounded-lg shadow p-4 text-center"
          >
            Lancez l'analyse SEO pour obtenir la totalité des informations
            essentielles pour créer le meilleur contenu !
          </button>
        </div>
      )}
    </Box>
  );
};

export default LaunchAnalysisBtn;
